import { PARTNER_OPTIONS } from "store"

declare const RASA_PUBLIC_SERVICE_API: string

export const SESSION_STORAGE_KEY = 'RASA_SESSION'

export const getPublicServerUrl = (): string => {
  return `${RASA_PUBLIC_SERVICE_API}`
}

export const getPartnerOptions = (): Record<string, any> => {
  try {
    const config = window.localStorage.getItem(PARTNER_OPTIONS)
    return config ? JSON.parse(config) : {}
  } catch (error) {
    return {}
  }
}

export const getOptionValue = (key: string, defaultValue: string): string => {
  const partnerOptions = getPartnerOptions();

  if(!partnerOptions) {
    return defaultValue
  }

  return partnerOptions[key] || defaultValue
}

let BRAND_NAME: string = getOptionValue('BRAND_NAME', 'rasa.io')
let RASA_HOME_URL: string = getOptionValue('HOME_URL', 'http://www.rasa.io')
let RASA_PRESS_URL: string = getOptionValue('PRESS_URL', RASA_HOME_URL + '/news')
let RASA_PRIVACY_URL: string = getOptionValue('PRIVACY_URL', RASA_HOME_URL + '/privacy')
let RASA_PRICING_URL = getOptionValue('PRICING_URL', RASA_HOME_URL + '/pricing')
let RASA_HELP_BASE_URL: string = getOptionValue('HELP_URL', 'https://help.rasa.io')
let RASA_COMMUNITY_URL: string = getOptionValue('COMMUNITY_URL', null)
let RASA_COMMUNITY_LABEL: string = getOptionValue('COMMUNITY_LABEL', 'Learning Hub & Community')
let RASA_HELP_HUBSPOT_DOCUMENTATION = getOptionValue('HELP_HUBSPOT_DOCUMENTATION', null)
let RASA_HELP_GROWTHZONE_DOCUMENTATION = getOptionValue('HELP_GROWTHZONE_DOCUMENTATION', 'https://help.rasa.io/how-to-integrate-rasa.io-with-growthzone')
let RASA_HELP_INFORMZ_INTEGRATION = getOptionValue('HELP_INFORMZ_INTEGRATION', 'https://help.rasa.io/connecting-informz-and-rasa.io')
let RASA_HELP_IP_ADDRESSES = getOptionValue('HELP_IP_ADDRESSES', 'https://help.rasa.io/ip-addresses')
let RASA_HELP_SALESFORCE_DOCUMENTATION = getOptionValue('HELP_SALESFORCE_DOCUMENTATION', null)
let RASA_HELP_INTEGRATION_WORK = getOptionValue('HELP_INTEGRATION_WORK', null)
let RASA_HELP_EMBED_TOP_ARTICLE = getOptionValue('HELP_EMBED_TOP_ARTICLE', null)
let RASA_HELP_ANTI_SPAM_EMAIL_DELIVERABILITY = getOptionValue('HELP_ANTI_SPAM_EMAIL_DELIVERABILITY', null)
let RASA_HELP_CUSTOM_TEMPLATE_EDITOR = getOptionValue('RASA_HELP_CUSTOM_TEMPLATE_EDITOR', 'https://help.rasa.io/how-to-use-the-custom-template-editor')
let RASA_HELP_OVERVIEW_OF_DOMAIN_AUTH = getOptionValue('HELP_OVERVIEW_OF_DOMAIN_AUTH', null)
let RASA_HELP_HOW_TO_AUTH_DOMAIN = getOptionValue('HELP_HOW_TO_AUTH_DOMAIN', null)
let RASA_HELP_FIND_RSS_FEED = getOptionValue('HELP_FIND_RSS_FEED', null)
let RASA_HELP_SUBSCRIBER_PERMISSION = getOptionValue('HELP_SUBSCRIBER_PERMISSION', null)
let RASA_HELP_DMARC = getOptionValue('HELP_DMARC', null)
let RASA_HELP_ADD_GOOGLE_NEWS = getOptionValue('HELP_ADD_GOOGLE_NEWS', null)
let SUPPORT_EMAIL = getOptionValue('SUPPORT_EMAIL', 'support@rasa.io')
let SUPPORT_MAIL_TO = `mailto:${SUPPORT_EMAIL}`
let HELP_MAIL_TO = getOptionValue('HELP_MAIL_TO', 'mailto:help@rasa.io')
const DEFAULT_DATE_FORMAT = 'yyyy-MM-dd'
let EMAIL_FOOTER_IMAGE = getOptionValue('EMAIL_FOOTER_IMAGE', null)
let WHITELABEL_LOGO_URL = getOptionValue('WHITELABEL_LOGO_URL', null)
let SOURCE_VIDEO = getOptionValue('SOURCE_VIDEO', null)
let PROMO_VIDEO = getOptionValue('PROMO_VIDEO', null)
export const updateConstants = () => {
  BRAND_NAME = getOptionValue('BRAND_NAME', 'rasa.io')
  RASA_HOME_URL = getOptionValue('HOME_URL', 'http://www.rasa.io')
  RASA_PRESS_URL = getOptionValue('PRESS_URL', RASA_HOME_URL + '/news')
  RASA_PRIVACY_URL = getOptionValue('PRIVACY_URL', RASA_HOME_URL + '/privacy')
  RASA_PRICING_URL = getOptionValue('PRICING_URL', RASA_HOME_URL + '/pricing')
  RASA_HELP_BASE_URL = getOptionValue('HELP_URL', 'https://help.rasa.io')
  RASA_COMMUNITY_URL = getOptionValue('COMMUNITY_URL', null)
  RASA_COMMUNITY_LABEL = getOptionValue('COMMUNITY_LABEL', 'Learning Hub & Community')
  RASA_HELP_HUBSPOT_DOCUMENTATION = getOptionValue('HELP_HUBSPOT_DOCUMENTATION', null)
  RASA_HELP_GROWTHZONE_DOCUMENTATION = getOptionValue('HELP_GROWTHZONE_DOCUMENTATION', 'https://help.rasa.io/how-to-integrate-rasa.io-with-growthzone')
  RASA_HELP_INFORMZ_INTEGRATION = getOptionValue('HELP_INFORMZ_INTEGRATION', 'https://help.rasa.io/connecting-informz-and-rasa.io')
  RASA_HELP_IP_ADDRESSES = getOptionValue('HELP_IP_ADDRESSES', 'https://help.rasa.io/ip-addresses')
  RASA_HELP_SALESFORCE_DOCUMENTATION = getOptionValue('HELP_SALESFORCE_DOCUMENTATION', null)
  RASA_HELP_INTEGRATION_WORK = getOptionValue('HELP_INTEGRATION_WORK', null)
  RASA_HELP_EMBED_TOP_ARTICLE = getOptionValue('HELP_EMBED_TOP_ARTICLE', null)
  RASA_HELP_ANTI_SPAM_EMAIL_DELIVERABILITY = getOptionValue('HELP_ANTI_SPAM_EMAIL_DELIVERABILITY', null)
  RASA_HELP_CUSTOM_TEMPLATE_EDITOR = getOptionValue('RASA_HELP_CUSTOM_TEMPLATE_EDITOR', 'https://help.rasa.io/how-to-use-the-custom-template-editor')
  RASA_HELP_OVERVIEW_OF_DOMAIN_AUTH = getOptionValue('HELP_OVERVIEW_OF_DOMAIN_AUTH', null)
  RASA_HELP_HOW_TO_AUTH_DOMAIN = getOptionValue('HELP_HOW_TO_AUTH_DOMAIN', null)
  RASA_HELP_FIND_RSS_FEED = getOptionValue('HELP_FIND_RSS_FEED', null)
  RASA_HELP_SUBSCRIBER_PERMISSION = getOptionValue('HELP_SUBSCRIBER_PERMISSION', null)
  RASA_HELP_DMARC = getOptionValue('HELP_DMARC', null)
  RASA_HELP_ADD_GOOGLE_NEWS = getOptionValue('HELP_ADD_GOOGLE_NEWS', null)
  SUPPORT_EMAIL = getOptionValue('SUPPORT_EMAIL', 'support@rasa.io')
  SUPPORT_MAIL_TO = `mailto:${SUPPORT_EMAIL}`
  HELP_MAIL_TO = getOptionValue('HELP_MAIL_TO', 'mailto:help@rasa.io')
  EMAIL_FOOTER_IMAGE = getOptionValue('EMAIL_FOOTER_IMAGE', null)
  WHITELABEL_LOGO_URL = getOptionValue('WHITELABEL_LOGO_URL', null)
  SOURCE_VIDEO = getOptionValue('SOURCE_VIDEO', null)
  PROMO_VIDEO = getOptionValue('PROMO_VIDEO', null)
}

export {
  BRAND_NAME,
  RASA_HOME_URL,
  RASA_PRESS_URL,
  RASA_PRIVACY_URL,
  RASA_PRICING_URL,
  RASA_HELP_BASE_URL,
  RASA_COMMUNITY_URL,
  RASA_COMMUNITY_LABEL,
  RASA_HELP_HUBSPOT_DOCUMENTATION,
  RASA_HELP_GROWTHZONE_DOCUMENTATION,
  RASA_HELP_INFORMZ_INTEGRATION,
  RASA_HELP_IP_ADDRESSES,
  RASA_HELP_SALESFORCE_DOCUMENTATION,
  RASA_HELP_INTEGRATION_WORK,
  RASA_HELP_EMBED_TOP_ARTICLE,
  RASA_HELP_ANTI_SPAM_EMAIL_DELIVERABILITY,
  RASA_HELP_CUSTOM_TEMPLATE_EDITOR,
  RASA_HELP_OVERVIEW_OF_DOMAIN_AUTH,
  RASA_HELP_HOW_TO_AUTH_DOMAIN,
  RASA_HELP_FIND_RSS_FEED,
  RASA_HELP_SUBSCRIBER_PERMISSION,
  RASA_HELP_DMARC,
  RASA_HELP_ADD_GOOGLE_NEWS,
  SUPPORT_EMAIL,
  SUPPORT_MAIL_TO,
  HELP_MAIL_TO,
  DEFAULT_DATE_FORMAT,
  EMAIL_FOOTER_IMAGE,
  WHITELABEL_LOGO_URL,
  SOURCE_VIDEO,
  PROMO_VIDEO,
}

export const STATUS_CODES = {
  UNPROCESSABLE: 422
}

export const IGNORE_SENTRY_ERROR = ['MissingToken']
